declare let window: any;

function analyticsHasLoaded(name) {
  if (!window.analytics) {
    console.warn(`Segment: ${name} has not been loaded on the page`); // eslint-disable-line no-console
    return false;
  }
  return true;
}

// Segment docs: https://segment.com/docs/connections/sources/catalog/libraries/website/javascript/#track
export async function sendSegmentEvent(eventName, eventProperties) {
  function sendEvent(): Promise<void> {
    console.log(`Segment: ${eventName} is loading on the page`); // eslint-disable-line no-console
    return new Promise((resolve) => {
      window.analytics.track(eventName, eventProperties, () => {
        resolve();
      });
    });
  }

  if (analyticsHasLoaded(eventName)) {
    await sendEvent();
  } else {
    window.addEventListener('segmentLoaded', () => {
      sendEvent();
    });
  }
}

// Segment docs: https://segment.com/docs/connections/sources/catalog/libraries/website/javascript/#page
export async function sendSegmentPageview(pageName, pageProperties?) {
  function sendEvent() {
    console.log(`Segment: Send pageview is loading on the page`); // eslint-disable-line no-console
    return window.analytics.page(pageName, pageProperties);
  }

  if (analyticsHasLoaded('Send pageview')) {
    await sendEvent();
  } else {
    window.addEventListener('segmentLoaded', () => {
      sendEvent();
    });
  }
}

// Segment docs: https://segment.com/docs/connections/sources/catalog/libraries/website/javascript/#identify
export async function identifyUserInSegment(userID, identifyProperties) {
  function sendEvent() {
    console.log(`Segment: Identify user is loading on the page`); // eslint-disable-line no-console
    return window.analytics.identify(userID, identifyProperties);
  }

  if (analyticsHasLoaded('Identify user')) {
    await sendEvent();
  } else {
    window.addEventListener('segmentLoaded', () => {
      sendEvent();
    });
  }
}
